var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundtrackTxtImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 180,
    viewBox: "0 0 537 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_5104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.973 21.265V12.1815H172.897C172.848 12.2626 172.784 12.3599 172.735 12.441C170.954 14.7768 168.85 17.1288 166.761 19.4645L165.256 18.2156C167.182 15.9933 169.141 13.8036 170.792 11.5976C171.278 10.965 171.489 10.2188 171.489 9.21314V6.09879H165.887V4.13611H173.658V9.13204C173.658 9.48889 173.642 9.86197 173.593 10.1702H175.973V3.40618H178.158V21.265H175.973ZM180.392 21.7841V3.19531H182.594V21.8003H180.392V21.7841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.507 12.9114C186.253 12.9114 183.873 10.8838 183.873 7.98037C183.873 5.07689 186.253 3.04932 189.507 3.04932C192.761 3.04932 195.14 5.07689 195.14 7.98037C195.14 10.8838 192.761 12.9114 189.507 12.9114ZM185.945 21.6381V14.4199H200.175V21.6381H185.945ZM189.507 4.99578C187.451 4.99578 186.091 6.16366 186.091 7.98037C186.091 9.79707 187.451 10.965 189.507 10.965C191.563 10.965 192.923 9.79707 192.923 7.98037C192.923 6.16366 191.563 4.99578 189.507 4.99578ZM197.974 16.3826H188.163V19.6754H197.974V16.3826ZM197.974 13.4954V3.1953H200.175V13.4954H197.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.795 13.5115V11.5488H220.105V13.5115H201.795ZM207.445 10.2188C204.855 10.2188 203.041 8.79135 203.041 6.66645C203.041 4.54156 204.855 3.13037 207.445 3.13037H214.455C217.045 3.13037 218.858 4.54156 218.858 6.66645C218.858 8.79135 217.045 10.2188 214.455 10.2188H207.445ZM203.527 21.638V15.2147H218.34V21.638H203.527ZM207.623 4.99574C206.069 4.99574 205.243 5.61212 205.243 6.65023C205.243 7.68835 206.069 8.33717 207.623 8.33717H214.244C215.798 8.33717 216.624 7.70457 216.624 6.65023C216.624 5.5959 215.798 4.99574 214.244 4.99574H207.623ZM216.122 17.0801H205.729V19.7565H216.122V17.0801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.851 13.2847C222.597 13.2847 220.314 11.1274 220.314 8.2239C220.314 5.32042 222.613 3.16309 225.851 3.16309C229.089 3.16309 231.388 5.32042 231.388 8.2239C231.388 11.1274 229.089 13.2847 225.851 13.2847ZM234.172 21.8492V16.8046H222.273V14.8419H236.374V21.8492H234.156H234.172ZM225.851 5.06089C223.827 5.06089 222.516 6.35854 222.516 8.20768C222.516 10.0568 223.827 11.3545 225.851 11.3545C227.875 11.3545 229.186 10.0568 229.186 8.20768C229.186 6.35854 227.875 5.06089 225.851 5.06089ZM234.172 13.9173V3.19553H236.39V7.23445H238.883V9.22958H236.39V13.9173H234.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.754 5.62878H244.145V3.66609H253.955V7.73745C253.955 9.22974 253.486 9.92723 252.142 10.5112C249.681 11.5817 246.767 12.7334 244.096 13.7228L243.238 12.0197C245.828 11.014 248.726 9.89479 250.863 8.88911C251.495 8.59714 251.737 8.25651 251.737 7.3806V5.62878H251.754ZM249.698 21.7682C247.043 21.7682 245.132 20.2759 245.132 17.9564C245.132 15.6369 247.043 14.1446 249.698 14.1446H255.768C258.423 14.1446 260.334 15.6369 260.334 17.9564C260.334 20.2759 258.423 21.7682 255.768 21.7682H249.698ZM249.827 16.1073C248.354 16.1073 247.334 16.7399 247.334 17.9564C247.334 19.1729 248.354 19.8055 249.827 19.8055H255.639C257.112 19.8055 258.132 19.1729 258.132 17.9564C258.132 16.7399 257.112 16.1073 255.639 16.1073H249.827ZM257.646 13.5606V11.5006H253.923V9.57037H257.646V7.16973H254.797V5.23948H257.646V3.21191H259.848V13.5769H257.646V13.5606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.117 16.7719V12.0031H271.779C270.775 13.0899 269.318 13.7711 267.57 13.7711C264.316 13.7711 262.033 11.4354 262.033 8.51566C262.033 5.59596 264.332 3.26019 267.57 3.26019C269.383 3.26019 270.888 3.99012 271.86 5.12556H276.101V3.19531H278.303V16.7719H276.101H276.117ZM264.089 21.6381V15.2959H266.291V19.6754H278.756V21.6381H264.073H264.089ZM267.586 5.17422C265.562 5.17422 264.251 6.66651 264.251 8.51566C264.251 10.3648 265.562 11.8571 267.586 11.8571C269.61 11.8571 270.921 10.3648 270.921 8.51566C270.921 6.66651 269.61 5.17422 267.586 5.17422ZM276.117 7.12069H272.928C273.058 7.57486 273.123 8.02904 273.123 8.49944C273.123 9.03472 273.042 9.52133 272.912 9.99173H276.117V7.12069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.877 18.4913V4.11988H288.907V6.08257H283.079V16.5286H289.473V18.4913H280.877ZM295.479 21.7841V12.0842H292.921V21.265H290.736V3.40618H292.921V10.0891H295.479V3.19531H297.681V21.8003H295.479V21.7841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.863 19.497V17.6478H304.465V15.7987C301.858 15.5067 300.272 14.0793 300.272 11.922C300.272 9.48888 302.311 7.98037 305.582 7.98037C308.852 7.98037 310.892 9.48888 310.892 11.922C310.892 14.0793 309.305 15.4905 306.715 15.7987V17.6478H312.478V19.497H298.863ZM299.77 7.15312V5.30397H304.481V3.04932H306.682V5.30397H311.393V7.15312H299.754H299.77ZM305.598 9.78085C303.639 9.78085 302.49 10.7216 302.49 11.9057C302.49 13.0898 303.639 14.0306 305.598 14.0306C307.557 14.0306 308.706 13.0898 308.706 11.9057C308.706 10.7216 307.557 9.78085 305.598 9.78085ZM313.32 21.8165V3.1953H315.522V21.8165H313.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8549 22.2871H5.77942V7.8184H16.0755V16.4964H11.5588V13.9335H13.5177V10.365H8.33725V19.7405H19.3133V4.39586H2.55784V22.2871H0V1.83301H21.8549V22.2871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2264 10.4136L39.5178 14.1281L43.2898 13.8361L39.5663 19.7566L33.4955 12.1168L40.5215 2.15734L37.478 0L29.6426 11.1111L29.7073 13.3495L38.2874 24.1362L41.3147 23.9578L48.4054 12.6683L46.6894 9.82966L39.2264 10.4136Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0344 2.15734L82.0603 12.1168L75.9895 19.7566L72.2823 13.8361L76.0381 14.1281L76.3457 10.4136L68.8664 9.82966L67.1504 12.6683L74.2411 23.9578L77.2684 24.1362L85.8485 13.3495L85.9133 11.1111L78.0779 0L75.0344 2.15734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9348 1.75167L61.5999 0.097168L57.9089 7.54241L54.3959 0.129609L51.0286 1.73545L55.8043 11.7922L50.543 22.368L53.8779 24.0225L57.8279 16.0744L61.5838 24.0063L64.951 22.4004L59.9325 11.8246L64.9348 1.75167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7997 0.794922L96.4199 3.47132L103.009 9.40804L93.3926 23.3253H106.344V19.7405H100.224L107.752 8.85654L98.7997 0.794922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.499 0.794922L128.103 3.47132L134.708 9.40804L125.092 23.3253H138.027V19.7405H131.923L139.451 8.85654L130.499 0.794922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.158 10.2498L115.258 12.1538L117.158 14.0578L119.058 12.1538L117.158 10.2498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.964 0.84375L109.242 12.3766L117.045 23.293L125.091 11.8575L116.964 0.859971V0.84375ZM117.029 17.5185L113.403 12.2792L117.11 7.05623L120.898 11.8413L117.045 17.5185H117.029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2124 9.2147L89.1445 12.2886L92.2124 15.3624L95.2803 12.2886L92.2124 9.2147Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.364 13.1061L153.487 13.3494L153.94 2.43292L150.621 1.42725L142.041 15.5067L143.806 18.2155L149.747 17.4532L149.536 22.5789L153.114 22.7248L153.357 16.999L155.85 16.6746L155.397 13.1223L155.364 13.1061ZM149.876 13.8035L147.043 14.1766L150.071 9.1969L149.876 13.8035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7679 100.714V55.069H0V46.5532H41.0225V55.069H25.2384V100.714H15.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63 100.714V72.2627C74.63 71.5814 74.0796 71.0299 73.4644 71.0299H56.7252V100.73H47.4004V44.1362H56.7252V62.7574H76.1356C80.3932 62.7574 83.9548 66.1313 83.9548 70.592V100.697H74.63V100.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4637 100.714C95.2061 100.714 91.6445 97.34 91.6445 92.8793V70.6085C91.6445 66.1478 95.2061 62.7739 99.4637 62.7739H120.736C124.994 62.7739 128.555 66.1478 128.555 70.6085V78.9296C128.555 83.3903 125.673 86.0829 121.416 86.0829H100.969V91.241C100.969 91.9223 101.52 92.4738 102.135 92.4738H117.369C117.984 92.4738 118.534 91.9223 118.534 91.241V88.4186H127.859V92.8793C127.859 97.34 124.297 100.714 120.04 100.714H99.4637ZM119.214 72.2467C119.214 71.5655 118.664 71.014 118.049 71.014H102.135C101.52 71.014 100.969 71.5655 100.969 72.2467V78.5079H118.049C118.664 78.5079 119.214 77.9564 119.214 77.2751V72.263V72.2467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.126 100.714V55.069H151.059V46.5532H165.596V100.714H156.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.366 75.7339C174.889 75.7339 172.801 73.7713 172.801 71.1597V68.1589H178.24V70.2027C178.24 70.6083 178.564 70.9164 178.92 70.9164H188.196C188.553 70.9164 188.876 70.592 188.876 70.2027V67.5101C188.876 67.1046 188.553 66.7802 188.196 66.7802H177.56C175.083 66.7802 172.995 64.8175 172.995 62.206V58.1509C172.995 55.5393 175.067 53.5767 177.56 53.5767H189.362C191.839 53.5767 193.927 55.5393 193.927 58.1509V60.9895H188.488V59.1079C188.488 58.7024 188.164 58.3779 187.808 58.3779H179.131C178.774 58.3779 178.451 58.7024 178.451 59.1079V61.6383C178.451 62.0438 178.774 62.3682 179.131 62.3682H189.767C192.244 62.3682 194.332 64.3309 194.332 66.9424V71.1435C194.332 73.755 192.26 75.7177 189.767 75.7177H177.366V75.7339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.632 75.734C203.155 75.734 201.067 73.7713 201.067 71.1598V58.4105H196.906V53.6092H201.067V44.5581H206.506V53.6092H212.982V58.4105H206.506V70.1866C206.506 70.5921 206.83 70.9003 207.186 70.9003H212.189V75.7016H205.632V75.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.707 100.713C239.385 100.713 235.742 97.2745 235.742 92.7328V54.5171C235.742 49.9754 239.385 46.5366 243.707 46.5366H274.579C278.902 46.5366 282.528 49.9754 282.528 54.5171V64.2008H273.057V56.3014C273.057 55.6201 272.507 55.0686 271.827 55.0686H246.443C245.763 55.0686 245.213 55.6201 245.213 56.3014V90.9485C245.213 91.6298 245.763 92.1813 246.443 92.1813H271.827C272.507 92.1813 273.057 91.6298 273.057 90.9485V77.5503H259.346V69.0345H282.528V92.749C282.528 97.2908 278.885 100.73 274.579 100.73H243.707V100.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.678 100.714L311.975 79.6757L296.401 100.714H284.939L306.552 71.9871L286.801 46.6182H298.263L312.056 64.3472L325.849 46.6182H337.31L317.479 71.9871L339.156 100.714H327.694H327.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.182 100.713C345.859 100.713 342.217 97.2745 342.217 92.7328V54.5171C342.217 49.9754 345.859 46.5366 350.182 46.5366H381.054C385.376 46.5366 389.019 49.9754 389.019 54.5171V64.2008H379.548V56.3014C379.548 55.6201 378.998 55.0686 378.318 55.0686H352.934C352.254 55.0686 351.703 55.6201 351.703 56.3014V90.9485C351.703 91.6298 352.254 92.1813 352.934 92.1813H378.318C378.998 92.1813 379.548 91.6298 379.548 90.9485V77.5503H365.836V69.0345H389.019V92.749C389.019 97.2908 385.376 100.73 381.054 100.73H350.182V100.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98444 180.194C4.66202 180.194 1.01953 176.755 1.01953 172.214V162.043H10.49V170.429C10.49 171.111 11.0404 171.662 11.7204 171.662H34.0124C34.6923 171.662 35.2427 171.111 35.2427 170.429V157.096C35.2427 156.415 34.6923 155.863 34.0124 155.863H9.32441C5.00199 155.863 1.3595 152.425 1.3595 147.883V133.998C1.3595 129.456 5.00199 126.018 9.32441 126.018H36.0846C40.407 126.018 44.0495 129.456 44.0495 133.998V142.514H34.579V135.782C34.579 135.101 34.0286 134.55 33.3486 134.55H12.0765C11.3966 134.55 10.8462 135.101 10.8462 135.782V146.099C10.8462 146.78 11.3966 147.331 12.0765 147.331H36.7645C41.0869 147.331 44.7132 150.77 44.7132 155.296V172.198C44.7132 176.739 41.0707 180.178 36.7645 180.178H8.98444V180.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.644 180.194C56.3216 180.194 52.6953 176.755 52.6953 172.214V133.998C52.6953 129.456 56.3378 126.018 60.644 126.018H91.5161C95.8386 126.018 99.4649 129.456 99.4649 133.998V172.214C99.4649 176.755 95.8224 180.194 91.5161 180.194H60.644ZM89.9944 135.782C89.9944 135.101 89.444 134.55 88.764 134.55H63.3799C62.7 134.55 62.1496 135.101 62.1496 135.782V170.429C62.1496 171.111 62.7 171.662 63.3799 171.662H88.764C89.444 171.662 89.9944 171.111 89.9944 170.429V135.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.525 180.194C111.203 180.194 107.561 176.755 107.561 172.214V126.034H117.031V170.429C117.031 171.111 117.581 171.662 118.261 171.662H143.645C144.325 171.662 144.876 171.111 144.876 170.429V126.034H154.346V172.214C154.346 176.755 150.704 180.194 146.398 180.194H115.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.817 180.194L172.104 136.204C172.104 141.362 172.314 149.262 172.314 154.42V180.194H162.844V126.034H176.216L198.718 168.029V126.034H208.189V180.194H194.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.125 180.194V126.034H252.659C259.038 126.034 263.911 130.916 263.911 137.307V168.921C263.911 175.312 259.038 180.194 252.659 180.194H217.125ZM254.44 137.161C254.44 135.717 253.275 134.549 251.834 134.549H226.595V171.662H251.834C253.275 171.662 254.44 170.494 254.44 169.051V137.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.942 180.194V134.549H287.158V126.034H328.181V134.549H312.397V180.194H302.926H302.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.037 180.194L356.851 158.264H344.304V180.194H334.834V126.034H367.552C371.874 126.034 375.5 129.472 375.5 134.014V150.3C375.5 154.841 371.858 158.28 367.552 158.28H367.341L378.722 180.21H368.021L368.037 180.194ZM366.046 135.782C366.046 135.101 365.496 134.549 364.816 134.549H344.304V149.732H364.816C365.496 149.732 366.046 149.18 366.046 148.499V135.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.476 180.194L416.878 167.477H394.586L389.989 180.194H379.773L400.625 126.034H410.921L431.772 180.194H421.476ZM409.755 147.542C408.865 145.142 406.809 139.773 405.773 136.545C404.672 139.773 402.681 145.142 401.79 147.542L397.678 158.945H413.867L409.755 147.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.511 180.194C439.189 180.194 435.562 176.755 435.562 172.214V133.998C435.562 129.456 439.205 126.018 443.511 126.018H474.383C478.706 126.018 482.332 129.456 482.332 133.998V146.164H472.862V135.782C472.862 135.101 472.311 134.55 471.631 134.55H446.247C445.567 134.55 445.017 135.101 445.017 135.782V170.429C445.017 171.111 445.567 171.662 446.247 171.662H471.631C472.311 171.662 472.862 171.111 472.862 170.429V159.919H482.332V172.214C482.332 176.755 478.69 180.194 474.383 180.194H443.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.949 180.194L505.384 155.101L500.025 160.875V180.194H490.555V126.034H500.025V147.607L519.986 126.034H532.338L512.037 147.964L534.394 180.194H522.932H522.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7679 100.714V55.069H0V46.5532H41.0225V55.069H25.2384V100.714H15.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63 100.714V72.2627C74.63 71.5814 74.0796 71.0299 73.4644 71.0299H56.7252V100.73H47.4004V44.1362H56.7252V62.7574H76.1356C80.3932 62.7574 83.9548 66.1313 83.9548 70.592V100.697H74.63V100.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4637 100.714C95.2061 100.714 91.6445 97.34 91.6445 92.8793V70.6085C91.6445 66.1478 95.2061 62.7739 99.4637 62.7739H120.736C124.994 62.7739 128.555 66.1478 128.555 70.6085V78.9296C128.555 83.3903 125.673 86.0829 121.416 86.0829H100.969V91.241C100.969 91.9223 101.52 92.4738 102.135 92.4738H117.369C117.984 92.4738 118.534 91.9223 118.534 91.241V88.4186H127.859V92.8793C127.859 97.34 124.297 100.714 120.04 100.714H99.4637ZM119.214 72.2467C119.214 71.5655 118.664 71.014 118.049 71.014H102.135C101.52 71.014 100.969 71.5655 100.969 72.2467V78.5079H118.049C118.664 78.5079 119.214 77.9564 119.214 77.2751V72.263V72.2467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.126 100.714V55.069H151.059V46.5532H165.596V100.714H156.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.366 75.7339C174.889 75.7339 172.801 73.7713 172.801 71.1597V68.1589H178.24V70.2027C178.24 70.6083 178.564 70.9164 178.92 70.9164H188.196C188.553 70.9164 188.876 70.592 188.876 70.2027V67.5101C188.876 67.1046 188.553 66.7802 188.196 66.7802H177.56C175.083 66.7802 172.995 64.8175 172.995 62.206V58.1509C172.995 55.5393 175.067 53.5767 177.56 53.5767H189.362C191.839 53.5767 193.927 55.5393 193.927 58.1509V60.9895H188.488V59.1079C188.488 58.7024 188.164 58.3779 187.808 58.3779H179.131C178.774 58.3779 178.451 58.7024 178.451 59.1079V61.6383C178.451 62.0438 178.774 62.3682 179.131 62.3682H189.767C192.244 62.3682 194.332 64.3309 194.332 66.9424V71.1435C194.332 73.755 192.26 75.7177 189.767 75.7177H177.366V75.7339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.632 75.734C203.155 75.734 201.067 73.7713 201.067 71.1598V58.4105H196.906V53.6092H201.067V44.5581H206.506V53.6092H212.982V58.4105H206.506V70.1866C206.506 70.5921 206.83 70.9003 207.186 70.9003H212.189V75.7016H205.632V75.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.707 100.713C239.385 100.713 235.742 97.2745 235.742 92.7328V54.5171C235.742 49.9754 239.385 46.5366 243.707 46.5366H274.579C278.902 46.5366 282.528 49.9754 282.528 54.5171V64.2008H273.057V56.3014C273.057 55.6201 272.507 55.0686 271.827 55.0686H246.443C245.763 55.0686 245.213 55.6201 245.213 56.3014V90.9485C245.213 91.6298 245.763 92.1813 246.443 92.1813H271.827C272.507 92.1813 273.057 91.6298 273.057 90.9485V77.5503H259.346V69.0345H282.528V92.749C282.528 97.2908 278.885 100.73 274.579 100.73H243.707V100.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.678 100.714L311.975 79.6757L296.401 100.714H284.939L306.552 71.9871L286.801 46.6182H298.263L312.056 64.3472L325.849 46.6182H337.31L317.479 71.9871L339.156 100.714H327.694H327.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.182 100.713C345.859 100.713 342.217 97.2745 342.217 92.7328V54.5171C342.217 49.9754 345.859 46.5366 350.182 46.5366H381.054C385.376 46.5366 389.019 49.9754 389.019 54.5171V64.2008H379.548V56.3014C379.548 55.6201 378.998 55.0686 378.318 55.0686H352.934C352.254 55.0686 351.703 55.6201 351.703 56.3014V90.9485C351.703 91.6298 352.254 92.1813 352.934 92.1813H378.318C378.998 92.1813 379.548 91.6298 379.548 90.9485V77.5503H365.836V69.0345H389.019V92.749C389.019 97.2908 385.376 100.73 381.054 100.73H350.182V100.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98444 180.194C4.66202 180.194 1.01953 176.755 1.01953 172.214V162.043H10.49V170.429C10.49 171.111 11.0404 171.662 11.7204 171.662H34.0124C34.6923 171.662 35.2427 171.111 35.2427 170.429V157.096C35.2427 156.415 34.6923 155.863 34.0124 155.863H9.32441C5.00199 155.863 1.3595 152.425 1.3595 147.883V133.998C1.3595 129.456 5.00199 126.018 9.32441 126.018H36.0846C40.407 126.018 44.0495 129.456 44.0495 133.998V142.514H34.579V135.782C34.579 135.101 34.0286 134.55 33.3486 134.55H12.0765C11.3966 134.55 10.8462 135.101 10.8462 135.782V146.099C10.8462 146.78 11.3966 147.331 12.0765 147.331H36.7645C41.0869 147.331 44.7132 150.77 44.7132 155.296V172.198C44.7132 176.739 41.0707 180.178 36.7645 180.178H8.98444V180.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.644 180.194C56.3216 180.194 52.6953 176.755 52.6953 172.214V133.998C52.6953 129.456 56.3378 126.018 60.644 126.018H91.5161C95.8386 126.018 99.4649 129.456 99.4649 133.998V172.214C99.4649 176.755 95.8224 180.194 91.5161 180.194H60.644ZM89.9944 135.782C89.9944 135.101 89.444 134.55 88.764 134.55H63.3799C62.7 134.55 62.1496 135.101 62.1496 135.782V170.429C62.1496 171.111 62.7 171.662 63.3799 171.662H88.764C89.444 171.662 89.9944 171.111 89.9944 170.429V135.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.525 180.194C111.203 180.194 107.561 176.755 107.561 172.214V126.034H117.031V170.429C117.031 171.111 117.581 171.662 118.261 171.662H143.645C144.325 171.662 144.876 171.111 144.876 170.429V126.034H154.346V172.214C154.346 176.755 150.704 180.194 146.398 180.194H115.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.817 180.194L172.104 136.204C172.104 141.362 172.314 149.262 172.314 154.42V180.194H162.844V126.034H176.216L198.718 168.029V126.034H208.189V180.194H194.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.125 180.194V126.034H252.659C259.038 126.034 263.911 130.916 263.911 137.307V168.921C263.911 175.312 259.038 180.194 252.659 180.194H217.125ZM254.44 137.161C254.44 135.717 253.275 134.549 251.834 134.549H226.595V171.662H251.834C253.275 171.662 254.44 170.494 254.44 169.051V137.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.942 180.194V134.549H287.158V126.034H328.181V134.549H312.397V180.194H302.926H302.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.037 180.194L356.851 158.264H344.304V180.194H334.834V126.034H367.552C371.874 126.034 375.5 129.472 375.5 134.014V150.3C375.5 154.841 371.858 158.28 367.552 158.28H367.341L378.722 180.21H368.021L368.037 180.194ZM366.046 135.782C366.046 135.101 365.496 134.549 364.816 134.549H344.304V149.732H364.816C365.496 149.732 366.046 149.18 366.046 148.499V135.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.476 180.194L416.878 167.477H394.586L389.989 180.194H379.773L400.625 126.034H410.921L431.772 180.194H421.476ZM409.755 147.542C408.865 145.142 406.809 139.773 405.773 136.545C404.672 139.773 402.681 145.142 401.79 147.542L397.678 158.945H413.867L409.755 147.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.511 180.194C439.189 180.194 435.562 176.755 435.562 172.214V133.998C435.562 129.456 439.205 126.018 443.511 126.018H474.383C478.706 126.018 482.332 129.456 482.332 133.998V146.164H472.862V135.782C472.862 135.101 472.311 134.55 471.631 134.55H446.247C445.567 134.55 445.017 135.101 445.017 135.782V170.429C445.017 171.111 445.567 171.662 446.247 171.662H471.631C472.311 171.662 472.862 171.111 472.862 170.429V159.919H482.332V172.214C482.332 176.755 478.69 180.194 474.383 180.194H443.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.949 180.194L505.384 155.101L500.025 160.875V180.194H490.555V126.034H500.025V147.607L519.986 126.034H532.338L512.037 147.964L534.394 180.194H522.932H522.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7679 100.714V55.069H0V46.5532H41.0225V55.069H25.2384V100.714H15.7679Z",
    stroke: "url(#paint0_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63 100.714V72.2627C74.63 71.5814 74.0796 71.0299 73.4644 71.0299H56.7252V100.73H47.4004V44.1362H56.7252V62.7574H76.1356C80.3932 62.7574 83.9548 66.1313 83.9548 70.592V100.697H74.63V100.714Z",
    stroke: "url(#paint1_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4637 100.714C95.2061 100.714 91.6445 97.3399 91.6445 92.8793V70.6085C91.6445 66.1478 95.2061 62.7739 99.4637 62.7739H120.736C124.994 62.7739 128.555 66.1478 128.555 70.6085V78.9296C128.555 83.3903 125.673 86.0829 121.416 86.0829H100.969V91.241C100.969 91.9223 101.52 92.4738 102.135 92.4738H117.369C117.984 92.4738 118.534 91.9223 118.534 91.241V88.4186H127.859V92.8793C127.859 97.3399 124.297 100.714 120.04 100.714H99.4637ZM119.214 72.2467C119.214 71.5655 118.664 71.014 118.049 71.014H102.135C101.52 71.014 100.969 71.5655 100.969 72.2467V78.5079H118.049C118.664 78.5079 119.214 77.9564 119.214 77.2751V72.263V72.2467Z",
    stroke: "url(#paint2_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.126 100.714V55.069H151.059V46.5532H165.596V100.714H156.126Z",
    stroke: "url(#paint3_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.366 75.7339C174.889 75.7339 172.801 73.7713 172.801 71.1598V68.1589H178.24V70.2027C178.24 70.6083 178.564 70.9164 178.92 70.9164H188.196C188.553 70.9164 188.876 70.592 188.876 70.2027V67.5101C188.876 67.1046 188.553 66.7802 188.196 66.7802H177.56C175.083 66.7802 172.995 64.8175 172.995 62.206V58.1509C172.995 55.5393 175.067 53.5767 177.56 53.5767H189.362C191.839 53.5767 193.927 55.5393 193.927 58.1509V60.9895H188.488V59.1079C188.488 58.7024 188.164 58.3779 187.808 58.3779H179.131C178.774 58.3779 178.451 58.7024 178.451 59.1079V61.6383C178.451 62.0438 178.774 62.3682 179.131 62.3682H189.767C192.244 62.3682 194.332 64.3309 194.332 66.9424V71.1435C194.332 73.755 192.26 75.7177 189.767 75.7177H177.366V75.7339Z",
    stroke: "url(#paint4_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.632 75.734C203.155 75.734 201.067 73.7713 201.067 71.1598V58.4105H196.906V53.6092H201.067V44.5581H206.506V53.6092H212.982V58.4105H206.506V70.1866C206.506 70.5921 206.83 70.9003 207.186 70.9003H212.189V75.7016H205.632V75.734Z",
    stroke: "url(#paint5_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.707 100.713C239.385 100.713 235.742 97.2745 235.742 92.7328V54.5171C235.742 49.9754 239.385 46.5366 243.707 46.5366H274.579C278.902 46.5366 282.528 49.9754 282.528 54.5171V64.2008H273.057V56.3014C273.057 55.6201 272.507 55.0686 271.827 55.0686H246.443C245.763 55.0686 245.213 55.6201 245.213 56.3014V90.9485C245.213 91.6298 245.763 92.1813 246.443 92.1813H271.827C272.507 92.1813 273.057 91.6298 273.057 90.9485V77.5503H259.346V69.0345H282.528V92.749C282.528 97.2908 278.885 100.73 274.579 100.73H243.707V100.713Z",
    stroke: "url(#paint6_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.678 100.714L311.975 79.6757L296.401 100.714H284.939L306.552 71.9871L286.801 46.6182H298.263L312.056 64.3472L325.849 46.6182H337.31L317.479 71.9871L339.156 100.714H327.694H327.678Z",
    stroke: "url(#paint7_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.182 100.713C345.859 100.713 342.217 97.2745 342.217 92.7328V54.5171C342.217 49.9754 345.859 46.5366 350.182 46.5366H381.054C385.376 46.5366 389.019 49.9754 389.019 54.5171V64.2008H379.548V56.3014C379.548 55.6201 378.998 55.0686 378.318 55.0686H352.934C352.254 55.0686 351.703 55.6201 351.703 56.3014V90.9485C351.703 91.6298 352.254 92.1813 352.934 92.1813H378.318C378.998 92.1813 379.548 91.6298 379.548 90.9485V77.5503H365.836V69.0345H389.019V92.749C389.019 97.2908 385.376 100.73 381.054 100.73H350.182V100.713Z",
    stroke: "url(#paint8_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98444 180.194C4.66202 180.194 1.01953 176.755 1.01953 172.214V162.043H10.49V170.429C10.49 171.111 11.0404 171.662 11.7204 171.662H34.0124C34.6923 171.662 35.2427 171.111 35.2427 170.429V157.096C35.2427 156.415 34.6923 155.863 34.0124 155.863H9.32441C5.00199 155.863 1.3595 152.425 1.3595 147.883V133.998C1.3595 129.456 5.00199 126.018 9.32441 126.018H36.0846C40.407 126.018 44.0495 129.456 44.0495 133.998V142.514H34.579V135.782C34.579 135.101 34.0286 134.55 33.3486 134.55H12.0765C11.3966 134.55 10.8462 135.101 10.8462 135.782V146.099C10.8462 146.78 11.3966 147.331 12.0765 147.331H36.7645C41.0869 147.331 44.7132 150.77 44.7132 155.296V172.198C44.7132 176.739 41.0707 180.178 36.7645 180.178H8.98444V180.194Z",
    stroke: "url(#paint9_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.644 180.194C56.3216 180.194 52.6953 176.755 52.6953 172.214V133.998C52.6953 129.456 56.3378 126.018 60.644 126.018H91.5161C95.8386 126.018 99.4649 129.456 99.4649 133.998V172.214C99.4649 176.755 95.8224 180.194 91.5161 180.194H60.644ZM89.9944 135.782C89.9944 135.101 89.444 134.55 88.764 134.55H63.3799C62.7 134.55 62.1496 135.101 62.1496 135.782V170.429C62.1496 171.111 62.7 171.662 63.3799 171.662H88.764C89.444 171.662 89.9944 171.111 89.9944 170.429V135.782Z",
    stroke: "url(#paint10_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.525 180.194C111.203 180.194 107.561 176.755 107.561 172.214V126.034H117.031V170.429C117.031 171.111 117.581 171.662 118.261 171.662H143.645C144.325 171.662 144.876 171.111 144.876 170.429V126.034H154.346V172.214C154.346 176.755 150.704 180.194 146.398 180.194H115.525Z",
    stroke: "url(#paint11_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.817 180.194L172.104 136.204C172.104 141.362 172.314 149.262 172.314 154.42V180.194H162.844V126.034H176.216L198.718 168.029V126.034H208.189V180.194H194.817Z",
    stroke: "url(#paint12_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.125 180.194V126.034H252.659C259.038 126.034 263.911 130.916 263.911 137.307V168.921C263.911 175.312 259.038 180.194 252.659 180.194H217.125ZM254.44 137.161C254.44 135.717 253.275 134.549 251.834 134.549H226.595V171.662H251.834C253.275 171.662 254.44 170.494 254.44 169.051V137.161Z",
    stroke: "url(#paint13_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.942 180.194V134.549H287.158V126.034H328.181V134.549H312.397V180.194H302.926H302.942Z",
    stroke: "url(#paint14_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.037 180.194L356.851 158.264H344.304V180.194H334.834V126.034H367.552C371.874 126.034 375.5 129.472 375.5 134.014V150.3C375.5 154.841 371.858 158.28 367.552 158.28H367.341L378.722 180.21H368.021L368.037 180.194ZM366.046 135.782C366.046 135.101 365.496 134.549 364.816 134.549H344.304V149.732H364.816C365.496 149.732 366.046 149.18 366.046 148.499V135.782Z",
    stroke: "url(#paint15_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.476 180.194L416.878 167.477H394.586L389.989 180.194H379.773L400.625 126.034H410.921L431.772 180.194H421.476ZM409.755 147.542C408.865 145.142 406.809 139.773 405.773 136.545C404.672 139.773 402.681 145.142 401.79 147.542L397.678 158.945H413.867L409.755 147.542Z",
    stroke: "url(#paint16_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.511 180.194C439.189 180.194 435.562 176.755 435.562 172.214V133.998C435.562 129.456 439.205 126.018 443.511 126.018H474.383C478.706 126.018 482.332 129.456 482.332 133.998V146.164H472.862V135.782C472.862 135.101 472.311 134.55 471.631 134.55H446.247C445.567 134.55 445.017 135.101 445.017 135.782V170.429C445.017 171.111 445.567 171.662 446.247 171.662H471.631C472.311 171.662 472.862 171.111 472.862 170.429V159.919H482.332V172.214C482.332 176.755 478.69 180.194 474.383 180.194H443.511Z",
    stroke: "url(#paint17_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.949 180.194L505.384 155.101L500.025 160.875V180.194H490.555V126.034H500.025V147.607L519.986 126.034H532.338L512.037 147.964L534.394 180.194H522.932H522.949Z",
    stroke: "url(#paint18_linear_248_5104)",
    strokeWidth: 0.416279,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7679 100.714V55.069H0V46.5532H41.0225V55.069H25.2384V100.714H15.7679Z",
    fill: "url(#paint19_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63 100.714V72.2627C74.63 71.5814 74.0796 71.0299 73.4644 71.0299H56.7252V100.73H47.4004V44.1362H56.7252V62.7574H76.1356C80.3932 62.7574 83.9548 66.1313 83.9548 70.592V100.697H74.63V100.714Z",
    fill: "url(#paint20_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4637 100.714C95.2061 100.714 91.6445 97.34 91.6445 92.8793V70.6085C91.6445 66.1478 95.2061 62.7739 99.4637 62.7739H120.736C124.994 62.7739 128.555 66.1478 128.555 70.6085V78.9296C128.555 83.3903 125.673 86.0829 121.416 86.0829H100.969V91.241C100.969 91.9223 101.52 92.4738 102.135 92.4738H117.369C117.984 92.4738 118.534 91.9223 118.534 91.241V88.4186H127.859V92.8793C127.859 97.34 124.297 100.714 120.04 100.714H99.4637ZM119.214 72.2467C119.214 71.5655 118.664 71.014 118.049 71.014H102.135C101.52 71.014 100.969 71.5655 100.969 72.2467V78.5079H118.049C118.664 78.5079 119.214 77.9564 119.214 77.2751V72.263V72.2467Z",
    fill: "url(#paint21_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.126 100.714V55.069H151.059V46.5532H165.596V100.714H156.126Z",
    fill: "url(#paint22_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.366 75.7339C174.889 75.7339 172.801 73.7713 172.801 71.1597V68.1589H178.24V70.2027C178.24 70.6083 178.564 70.9164 178.92 70.9164H188.196C188.553 70.9164 188.876 70.592 188.876 70.2027V67.5101C188.876 67.1046 188.553 66.7802 188.196 66.7802H177.56C175.083 66.7802 172.995 64.8175 172.995 62.206V58.1509C172.995 55.5393 175.067 53.5767 177.56 53.5767H189.362C191.839 53.5767 193.927 55.5393 193.927 58.1509V60.9895H188.488V59.1079C188.488 58.7024 188.164 58.3779 187.808 58.3779H179.131C178.774 58.3779 178.451 58.7024 178.451 59.1079V61.6383C178.451 62.0438 178.774 62.3682 179.131 62.3682H189.767C192.244 62.3682 194.332 64.3309 194.332 66.9424V71.1435C194.332 73.755 192.26 75.7177 189.767 75.7177H177.366V75.7339Z",
    fill: "url(#paint23_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.632 75.734C203.155 75.734 201.067 73.7713 201.067 71.1598V58.4105H196.906V53.6092H201.067V44.5581H206.506V53.6092H212.982V58.4105H206.506V70.1866C206.506 70.5921 206.83 70.9003 207.186 70.9003H212.189V75.7016H205.632V75.734Z",
    fill: "url(#paint24_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.707 100.713C239.385 100.713 235.742 97.2745 235.742 92.7328V54.5171C235.742 49.9754 239.385 46.5366 243.707 46.5366H274.579C278.902 46.5366 282.528 49.9754 282.528 54.5171V64.2008H273.057V56.3014C273.057 55.6201 272.507 55.0686 271.827 55.0686H246.443C245.763 55.0686 245.213 55.6201 245.213 56.3014V90.9485C245.213 91.6298 245.763 92.1813 246.443 92.1813H271.827C272.507 92.1813 273.057 91.6298 273.057 90.9485V77.5503H259.346V69.0345H282.528V92.749C282.528 97.2908 278.885 100.73 274.579 100.73H243.707V100.713Z",
    fill: "url(#paint25_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.678 100.714L311.975 79.6757L296.401 100.714H284.939L306.552 71.9871L286.801 46.6182H298.263L312.056 64.3472L325.849 46.6182H337.31L317.479 71.9871L339.156 100.714H327.694H327.678Z",
    fill: "url(#paint26_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.182 100.713C345.859 100.713 342.217 97.2745 342.217 92.7328V54.5171C342.217 49.9754 345.859 46.5366 350.182 46.5366H381.054C385.376 46.5366 389.019 49.9754 389.019 54.5171V64.2008H379.548V56.3014C379.548 55.6201 378.998 55.0686 378.318 55.0686H352.934C352.254 55.0686 351.703 55.6201 351.703 56.3014V90.9485C351.703 91.6298 352.254 92.1813 352.934 92.1813H378.318C378.998 92.1813 379.548 91.6298 379.548 90.9485V77.5503H365.836V69.0345H389.019V92.749C389.019 97.2908 385.376 100.73 381.054 100.73H350.182V100.713Z",
    fill: "url(#paint27_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98444 180.194C4.66202 180.194 1.01953 176.755 1.01953 172.214V162.043H10.49V170.429C10.49 171.111 11.0404 171.662 11.7204 171.662H34.0124C34.6923 171.662 35.2427 171.111 35.2427 170.429V157.096C35.2427 156.415 34.6923 155.863 34.0124 155.863H9.32441C5.00199 155.863 1.3595 152.425 1.3595 147.883V133.998C1.3595 129.456 5.00199 126.018 9.32441 126.018H36.0846C40.407 126.018 44.0495 129.456 44.0495 133.998V142.514H34.579V135.782C34.579 135.101 34.0286 134.55 33.3486 134.55H12.0765C11.3966 134.55 10.8462 135.101 10.8462 135.782V146.099C10.8462 146.78 11.3966 147.331 12.0765 147.331H36.7645C41.0869 147.331 44.7132 150.77 44.7132 155.296V172.198C44.7132 176.739 41.0707 180.178 36.7645 180.178H8.98444V180.194Z",
    fill: "url(#paint28_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.644 180.194C56.3216 180.194 52.6953 176.755 52.6953 172.214V133.998C52.6953 129.456 56.3378 126.018 60.644 126.018H91.5161C95.8386 126.018 99.4649 129.456 99.4649 133.998V172.214C99.4649 176.755 95.8224 180.194 91.5161 180.194H60.644ZM89.9944 135.782C89.9944 135.101 89.444 134.55 88.764 134.55H63.3799C62.7 134.55 62.1496 135.101 62.1496 135.782V170.429C62.1496 171.111 62.7 171.662 63.3799 171.662H88.764C89.444 171.662 89.9944 171.111 89.9944 170.429V135.782Z",
    fill: "url(#paint29_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.525 180.194C111.203 180.194 107.561 176.755 107.561 172.214V126.034H117.031V170.429C117.031 171.111 117.581 171.662 118.261 171.662H143.645C144.325 171.662 144.876 171.111 144.876 170.429V126.034H154.346V172.214C154.346 176.755 150.704 180.194 146.398 180.194H115.525Z",
    fill: "url(#paint30_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.817 180.194L172.104 136.204C172.104 141.362 172.314 149.262 172.314 154.42V180.194H162.844V126.034H176.216L198.718 168.029V126.034H208.189V180.194H194.817Z",
    fill: "url(#paint31_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.125 180.194V126.034H252.659C259.038 126.034 263.911 130.916 263.911 137.307V168.921C263.911 175.312 259.038 180.194 252.659 180.194H217.125ZM254.44 137.161C254.44 135.717 253.275 134.549 251.834 134.549H226.595V171.662H251.834C253.275 171.662 254.44 170.494 254.44 169.051V137.161Z",
    fill: "url(#paint32_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.942 180.194V134.549H287.158V126.034H328.181V134.549H312.397V180.194H302.926H302.942Z",
    fill: "url(#paint33_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.037 180.194L356.851 158.264H344.304V180.194H334.834V126.034H367.552C371.874 126.034 375.5 129.472 375.5 134.014V150.3C375.5 154.841 371.858 158.28 367.552 158.28H367.341L378.722 180.21H368.021L368.037 180.194ZM366.046 135.782C366.046 135.101 365.496 134.549 364.816 134.549H344.304V149.732H364.816C365.496 149.732 366.046 149.18 366.046 148.499V135.782Z",
    fill: "url(#paint34_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.476 180.194L416.878 167.477H394.586L389.989 180.194H379.773L400.625 126.034H410.921L431.772 180.194H421.476ZM409.755 147.542C408.865 145.142 406.809 139.773 405.773 136.545C404.672 139.773 402.681 145.142 401.79 147.542L397.678 158.945H413.867L409.755 147.542Z",
    fill: "url(#paint35_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.511 180.194C439.189 180.194 435.562 176.755 435.562 172.214V133.998C435.562 129.456 439.205 126.018 443.511 126.018H474.383C478.706 126.018 482.332 129.456 482.332 133.998V146.164H472.862V135.782C472.862 135.101 472.311 134.55 471.631 134.55H446.247C445.567 134.55 445.017 135.101 445.017 135.782V170.429C445.017 171.111 445.567 171.662 446.247 171.662H471.631C472.311 171.662 472.862 171.111 472.862 170.429V159.919H482.332V172.214C482.332 176.755 478.69 180.194 474.383 180.194H443.511Z",
    fill: "url(#paint36_linear_248_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.949 180.194L505.384 155.101L500.025 160.875V180.194H490.555V126.034H500.025V147.607L519.986 126.034H532.338L512.037 147.964L534.394 180.194H522.932H522.949Z",
    fill: "url(#paint37_linear_248_5104)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_248_5104",
    x1: 0,
    y1: 73.6253,
    x2: 534.394,
    y2: 73.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_248_5104",
    x1: -0.000533735,
    y1: 72.4249,
    x2: 534.393,
    y2: 72.4249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_248_5104",
    x1: -0.000472644,
    y1: 81.7358,
    x2: 534.393,
    y2: 81.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_248_5104",
    x1: 0.000464052,
    y1: -1.57318,
    x2: 534.394,
    y2: -1.57318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_248_5104",
    x1: 0.00105865,
    y1: 64.6715,
    x2: 534.395,
    y2: 64.6715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_248_5104",
    x1: 0.00139094,
    y1: 60.1461,
    x2: 534.395,
    y2: 60.1461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_248_5104",
    x1: 0.000237429,
    y1: -1.57357,
    x2: 534.394,
    y2: -1.57357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_248_5104",
    x1: -0.000373795,
    y1: 73.6578,
    x2: 534.393,
    y2: 73.6578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_248_5104",
    x1: 0.000841171,
    y1: -1.57357,
    x2: 534.395,
    y2: -1.57357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_248_5104",
    x1: -0.000365656,
    y1: 153.106,
    x2: 534.393,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_248_5104",
    x1: 0.000637663,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_248_5104",
    x1: 0.00191834,
    y1: 153.106,
    x2: 534.395,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_248_5104",
    x1: 0.000178825,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_248_5104",
    x1: 0.000222961,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_248_5104",
    x1: 0.000560093,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_248_5104",
    x1: 0.000199981,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_248_5104",
    x1: -0.000642844,
    y1: 153.106,
    x2: 534.409,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_248_5104",
    x1: 0.00197387,
    y1: 153.106,
    x2: 534.395,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_248_5104",
    x1: 0.000681581,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_248_5104",
    x1: 0,
    y1: 73.6253,
    x2: 534.394,
    y2: 73.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_248_5104",
    x1: -0.000533735,
    y1: 72.4249,
    x2: 534.393,
    y2: 72.4249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_248_5104",
    x1: -0.000471423,
    y1: 81.7358,
    x2: 534.409,
    y2: 81.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_248_5104",
    x1: 0.000464052,
    y1: -1.57318,
    x2: 534.394,
    y2: -1.57318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_248_5104",
    x1: 0.00105865,
    y1: 64.6715,
    x2: 534.395,
    y2: 64.6715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_248_5104",
    x1: 0.00139094,
    y1: 60.1461,
    x2: 534.395,
    y2: 60.1461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_248_5104",
    x1: 0.000237429,
    y1: -1.57357,
    x2: 534.394,
    y2: -1.57357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_248_5104",
    x1: -0.000373795,
    y1: 73.6578,
    x2: 534.393,
    y2: 73.6578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_248_5104",
    x1: 0.000841171,
    y1: -1.57357,
    x2: 534.395,
    y2: -1.57357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_248_5104",
    x1: -0.000365656,
    y1: 153.106,
    x2: 534.393,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_248_5104",
    x1: 0.000637663,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_248_5104",
    x1: 0.00191834,
    y1: 153.106,
    x2: 534.395,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_248_5104",
    x1: 0.000178825,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_248_5104",
    x1: 0.000222961,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_248_5104",
    x1: 0.000560093,
    y1: 153.106,
    x2: 534.41,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_248_5104",
    x1: 0.000199981,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_248_5104",
    x1: -0.00065518,
    y1: 153.106,
    x2: 534.393,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_248_5104",
    x1: 0.00197387,
    y1: 153.106,
    x2: 534.395,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_248_5104",
    x1: -0.0155054,
    y1: 153.106,
    x2: 534.394,
    y2: 153.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C51A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70BAA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E03E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_5104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 537,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundtrackTxtImg);
export default __webpack_public_path__ + "static/media/soundtrackTxtImg.7c4638ba986c851028479311caf99fde.svg";
export { ForwardRef as ReactComponent };